import React, { useState } from "react";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { BiX } from "react-icons/bi";

export default function DeleteTriviaPopup({
  onClose,
  open,
  item,
  onDeleteItem,
  isLibrary,
  type,
  isMessaging
}) {
  const handleDelete = () => {
    axios
      .delete(url.deleteTrivia(item._id))
      .then(data => {
        onDeleteItem(item._id);
      })
      .catch(err => {
        console.log(err);
      });
  };
  return (
    <Modal isOpen={open} size="sm" centered>
      <ModalHeader toggle={onClose}>
        <div>
          <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '4px' }}>
            Delete {isLibrary ? "Resource" : "Trivvy"}
          </div>
        </div>
      </ModalHeader>

      <ModalBody className="p-3">
        <div className="mt-2" style={{ fontSize: '14px', color: '#374151' }}>
          <p>
            You're about to delete <b>{item.name}</b>.
          </p>
          <p>
            Are you sure you want to Delete this{" "}
            {isLibrary ? "library" : isMessaging ? "message" : "Trivvy"} ?
          </p>
        </div>
      </ModalBody>
      <ModalFooter style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
        <Button
          color="link"
          onClick={onClose}
          style={{
            fontSize: '14px',
            fontWeight: '500',
            padding: '10px 20px',
            borderRadius: '6px',
            border: 'none',
            backgroundColor: 'transparent',
            color: '#6b7280',
            textDecoration: 'none',
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => (isLibrary ? onDeleteItem() : handleDelete())}
          style={{
            fontSize: '14px',
            fontWeight: '500',
            padding: '10px 20px',
            borderRadius: '6px',
            backgroundColor: '#dc2626', // Red for delete
            border: 'none',
            color: '#ffffff',
          }}
        >
          Yes, Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
}
